import { useState, useEffect, useCallback } from 'react';
import { supabase } from '../lib/supabase';
import { useAuth } from '../context/AuthContext';
import { Profile } from '../types';

export function useMembers() {
  const { ready } = useAuth();
  const [members, setMembers] = useState<Profile[]>([]);
  const [loading, setLoading] = useState(true);

  const fetchMembers = useCallback(async () => {
    setLoading(true);
    try {
      const { data, error } = await supabase
        .from('profiles')
        .select('*')
        .order('full_name', { ascending: true });

      if (!error && data) setMembers(data as Profile[]);
    } catch {
      // non-fatal
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (!ready) return;
    fetchMembers();
  }, [ready, fetchMembers]);

  return { members, loading, refetch: fetchMembers };
}

export function useHostingCounts() {
  const { ready } = useAuth();
  const [counts, setCounts] = useState<Record<string, number>>({});

  useEffect(() => {
    if (!ready) return;
    const run = async () => {
      try {
        const { data } = await supabase
          .from('events')
          .select('host_user_id')
          .eq('type', 'sabbath_lunch')
          .not('host_user_id', 'is', null);
        if (!data) return;
        const tally: Record<string, number> = {};
        data.forEach((e) => {
          if (e.host_user_id) {
            tally[e.host_user_id] = (tally[e.host_user_id] || 0) + 1;
          }
        });
        setCounts(tally);
      } catch {
        // non-fatal
      }
    };
    run();
  }, [ready]);

  return counts;
}
